import React, { useState, useEffect } from 'react';
import Header from '../Layout/Header';
import Sidebar from '../Layout/Sidebar'; 
import Footer from '../Layout/Footer';
import { putAPI,postAPI, uploadImageAPI,get, deleteAPI } from '../../services/ApiService';
import { apiBaseURL } from "../../Common/Constant";
import {DateFunc} from '../../services/Date';
import { masterData } from '../../api/master-data';


function Variable() {
    const [message, setMessage] = useState("");//for error handling
    const [histories, setHistoryList] = useState([]);//for error handling
    const [dataType, setDataType] = useState();//for error handling
    const [internetActivity, setInternetActivity] = useState([]);//for error handling
    
    const getInternetActivity = async() => {
        let res = await masterData({'moduleName':'internet-activity'});
        if(res.status === 1){
            if(res.payload.length > 0){
                const slugs = res.payload.map(activity => activity.slug);
                setInternetActivity(slugs);
                // setInternetActivity(res.payload)
            }
        }
    };
 

    const submitForm = async (e) => {
        e.preventDefault();
    
        // Retrieve the token from localStorage
        const _token = localStorage.getItem("token");
    
        if (!_token) {
            setMessage("Authentication token is missing. Please log in again.");
            return;
        }
    
        // Create FormData and append the file and dataType
        let formData = new FormData();
        formData.append('dataType', dataType);
        formData.append('file', e.target.file.files[0]);
    
        // Use XMLHttpRequest to upload the file and handle progress updates
        const xhr = new XMLHttpRequest();
        xhr.open('POST', `${apiBaseURL}/research/primary/population/upload/`, true);
        // xhr.timeout = 600000; // 5 minutes timeout (in milliseconds)
        // Set Authorization header
        xhr.setRequestHeader("Authorization", `Bearer ${_token}`);
    
        let msg = "";
        // Track upload progress
        xhr.upload.onprogress = (event) => {
            if (event.lengthComputable) {
                const percentComplete = Math.round((event.loaded / event.total) * 100);
                msg = `Uploading... ${percentComplete}% completed!`;
                if(percentComplete === 100) {
                    msg += `<br>Processing file...`;
                }
                setMessage(msg);
            }
        };
    
       
        // Handle server-sent progress updates
        xhr.onreadystatechange = (msg) => {
            if (xhr.readyState === 3) { // ReadyState 3 means the response is being received
                const responseText = xhr.responseText;
                const updates = responseText.split('\n'); // Split the response into lines
    
                updates.forEach((update) => {
                    if (update.trim().startsWith('data:')) {
                        try {
                            const progress = JSON.parse(update.trim().substring(5)); // Parse the JSON after 'data:'
                            console.log('Progress update:', progress);
    
                            // Display each step's message in real-time
                            setMessage(`Processing file...<br>Step: <b>${progress.sheetName}</b> - ${progress.message}`);
                        } catch (error) {
                            console.error('Error parsing progress update:', error);
                        }
                    }
                });
            }
        };
    
        // Handle response after file upload
        xhr.onload = () => {
            if (xhr.status === 200) {

                const responseText = xhr.responseText;
                const update = responseText.split('\n')[0]; // Split the response into lines
    
                //updates.forEach((update) => {
                    if (update.trim().startsWith('data:')) {
                        try {
                            const progress = JSON.parse(update.trim().substring(5)); // Parse the JSON after 'data:'
                            console.log('Progress update:', progress);
    
                            // Display each step's message in real-time
                            console.log('Progress update:', progress);
                            if(progress.step === 'error'){
                                setMessage(msg+`<br><b>ERROR: </b>- ${progress.message}`);
                            }else{
                                setMessage(msg+'<br>File Processing completed successfully!');
                            }
                        } catch (error) {
                            console.error('Error parsing progress update:', error);
                        }
                    }
                // });

                getList();
            } else {
                setMessage('An error occurred during the upload.');
            }
        };
    
        xhr.onerror = () => {
            setMessage('An error occurred while uploading the file.');
        };
    
        // Send the request
        xhr.send(formData);
    };
    const getList = async() =>{
        //setMessage();
        
        let data = {};//{page: pageInfo.current_page?pageInfo.current_page:0,recPerPage: 50, q: '',typeSlug:'primary-study'}
        let res = await get(`/research/primary/get-upload-history?dataType=all`, data);        
            if(res.status === 1){
                setHistoryList(res.payload)
            }else{
            setHistoryList([]);
            }
    }

    useEffect(()=>{
        getInternetActivity();
        getList();
    },[])


    return (
        <>

            <Header />
            <Sidebar />
            <div id="layout-wrapper">
                <div className="main-content">

                    <div className="page-content">
                        <div className="container-fluid">
                   
                                        <section className=''>
                                            <div className='container'>
                                                <div className='row g-3'>
                                                    
                                                    <div className='col-lg-12 col-md-12 col-sm-12'>
                                                        <div className='form-theme included-label rounded-4 shadow' >
                                                            <form className="row p-3" onSubmit={submitForm}>   
                                                                <div className="col-6 mb-3" style={{borderRight:"1px solid #ccc"}}>
                                                                    <label>Upload Type</label>
                                                                    <div style={{display:"flex",alignItems:"center",justifyContent:"flex-start",gap:"2rem"}}>
                                                                        <div className="form-check form-check-inline">
                                                                            <input
                                                                                className="form-check-input"
                                                                                type="radio"
                                                                                name="dataType"
                                                                                id="variableRadio"
                                                                                value="variable"
                                                                                required
                                                                                checked={dataType === "variable"}
                                                                                onChange={() => setDataType("variable")}
                                                                            />
                                                                            <label className="form-check-label" htmlFor="variableRadio">
                                                                                Variable Combinations
                                                                            </label>
                                                                        </div>
                                                                        <div className="form-check form-check-inline">
                                                                            <input
                                                                                className="form-check-input"
                                                                                type="radio"
                                                                                name="dataType"
                                                                                id="dataRadio"
                                                                                value="data"
                                                                                required
                                                                                checked={dataType === "data"}
                                                                                onChange={() => setDataType("data")}
                                                                            />
                                                                            <label className="form-check-label" htmlFor="dataRadio">
                                                                                Population /Internet users
                                                                            </label>
                                                                        </div>
                                                                    </div>
                                                                
                                                                    <label>Upload File</label>
                                                                    <div style={{display:"flex",alignItems:"center",justifyContent:"space-between"}}>
                                                                        <input className="form-control" type='file' name='file' required/>
                                                                        &nbsp; <button type='submit' className='btn btn-primary'>Submit</button>
                                                                    </div>
                                                                    <div dangerouslySetInnerHTML={{ __html: message }}></div>
                                                                </div>
                                                                <div className='col-6  mt-1 bl-1' style={{maxHeight:"200px",overflowY:"auto"}}>
                                                                    &nbsp; &nbsp; <span style={{display: "flex", alignItems: "center", fontWeight: "bold", marginBottom: "8px"}}>
                                                                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="#0d6efd" className="bi bi-info-circle" viewBox="0 0 16 16" style={{marginRight: "6px"}}>
                                                                            <path d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 1 8 0a8 8 0 0 1 0 16z"/>
                                                                            <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 .875-.252 1.02-.797l.088-.416c.066-.308.118-.438.288-.469l.45-.083.082-.38-2.29-.287zm-1.812-2.29c-.282 0-.506.224-.506.5s.224.5.506.5a.5.5 0 0 0 0-1z"/>
                                                                        </svg>
                                                                        Notes
                                                                    </span>
                                                                    <ul>
                                                                        <li>Upload file should be in .xlsx format</li>
                                                                        {/* <li>File should not exceed 5 MB</li> */}
                                                                        <li>File can have multiple sheets with each sheet having MAX 3lakhs rows</li>
                                                                        <li>File should contain only one header row with columns <br/>
                                                                            <b>For Variable Combinations:</b>(ID, Urban_Rural, State, District, Gender, Age_Group, Marital_Status, Education, City_Type, City, Occupation)
                                                                            <br/><br/>
                                                                            <b>For Population Data:</b>(ID, population, population-average-hh, internet-users, internet-users-average-hh, {internetActivity.join(", ")})
                                                                        </li>
                                                                    </ul>
                                                                </div>
                                        </form>
                                    </div>
                                </div>
                                <hr/>

                                <div className="row mt-2">
                                    <div className=" col-md-12 col-md-offset-3 ">
                                        <div className="card">

                                            {/* <!-- end card header --> */}

                                            <div className="card-body">
                                                <table className="table table-striped table-hover" style={{"text-align":"left"}}>
                                                    <thead>
                                                        <tr  style={{ color: "white", backgroundColor: "#3874ff" }}>
                                                            <th scope="col">#</th>
                                                            <th scope="col">Upload Time</th>
                                                            <th scope="col">Upload Type</th>
                                                            <th scope="col">File</th>
                                                            <th scope="col align-item-right" style={{width:"150px"}}>Records</th>
                                                            <th scope="col align-item-right" style={{width:"150px"}}>Uploaded</th>
                                                            <th scope="col align-item-right" style={{width:"150px"}}>Status</th>
                                                            <th scope="col align-item-right" style={{width:"150px"}}>Action</th>
                                                        </tr>
                                                    </thead>
                                                    {(histories && histories.length > 0 )? (
                                                    <tbody>
                                                        {histories?.map((list,index) => (
                                                            <tr key={list?.ID}>
                                                            <td>{index +1}</td>
                                                             
                                                            <td>{DateFunc.format(list.createdOn*1000,"dd mmm yyyy hh:mm ampm")}</td>
                                                            <td>{list.dataType}</td>
                                                            <td>
                                                                <a href={list.fileURL} target='_blank' ><svg xmlns="http://www.w3.org/2000/svg"  width="24" height="24" fill="currentColor" class="bi bi-filetype-xlsx" viewBox="0 0 16 16">
                                                                <path style={{color:"#3874ff"}} fill-rule="evenodd" d="M14 4.5V11h-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5zM7.86 14.841a1.13 1.13 0 0 0 .401.823q.195.162.479.252.284.091.665.091.507 0 .858-.158.355-.158.54-.44a1.17 1.17 0 0 0 .187-.656q0-.336-.135-.56a1 1 0 0 0-.375-.357 2 2 0 0 0-.565-.21l-.621-.144a1 1 0 0 1-.405-.176.37.37 0 0 1-.143-.299q0-.234.184-.384.188-.152.513-.152.214 0 .37.068a.6.6 0 0 1 .245.181.56.56 0 0 1 .12.258h.75a1.1 1.1 0 0 0-.199-.566 1.2 1.2 0 0 0-.5-.41 1.8 1.8 0 0 0-.78-.152q-.44 0-.777.15-.336.149-.527.421-.19.273-.19.639 0 .302.123.524t.351.367q.229.143.54.213l.618.144q.31.073.462.193a.39.39 0 0 1 .153.326.5.5 0 0 1-.085.29.56.56 0 0 1-.255.193q-.168.07-.413.07-.176 0-.32-.04a.8.8 0 0 1-.249-.115.58.58 0 0 1-.255-.384zm-3.726-2.909h.893l-1.274 2.007 1.254 1.992h-.908l-.85-1.415h-.035l-.853 1.415H1.5l1.24-2.016-1.228-1.983h.931l.832 1.438h.036zm1.923 3.325h1.697v.674H5.266v-3.999h.791zm7.636-3.325h.893l-1.274 2.007 1.254 1.992h-.908l-.85-1.415h-.035l-.853 1.415h-.861l1.24-2.016-1.228-1.983h.931l.832 1.438h.036z"/>
                                                                </svg></a>
                                                            </td>
                                                            <td>{list.numberOfRecords}</td>
                                                            <td>{list.totalRecordsInserted}</td>
                                                            <td>
                                                                { (list.numberOfRecords == list.totalRecordsInserted &&  list.numberOfRecords !=  null)? 
                                                                    <span className='badge bg-success'>Success</span>
                                                                    :
                                                                    <span className='badge bg-danger'>Issue</span>

                                                                }
                                                            </td>
                                                            <td></td>
                                                        </tr>
                                                        ))}
                                                    </tbody>
                                                    ):(<>
                                                        <tr>
                                                            <td colSpan={9} id="dataMessage" style={{padding:"50px 0"}}>No data found</td>
                                                        </tr>
                                                    </>)}
                                                </table>
                                                {/* <Pagination pageInfo={pageInfo} changePage={changePage} /> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </section>

                </div>
                </div>
                </div>
            </div>
            <Footer />

        </>
    );
};

export default Variable;
